import { guid } from '../util/helpers';

const fields = {
  basic: [],
  banner: {
    value: 'https://treatec.ams3.digitaloceanspaces.com/accor-signatur-generator/novotel/banner01.jpg'
  }
};

function seed() {
  const basic = [
    { label: 'Full name', key: 'fullName', type: 'text', value: 'John Doe' },
    { label: 'Job title', key: 'jobTitle', type: 'text', value: 'Manager' },
    {
      label: 'Company',
      key: 'company',
      type: 'text',
      value: 'ibis Styles München Ost Messe'
    },
    {
      label: 'Address',
      key: 'address',
      type: 'text',
      value: 'Kronstadter Str. 10 • 81677 München • Deutschland'
    },
    { label: 'Email', key: 'email', type: 'email', value: 'XXXXX@kjk-law.com' },
    { label: 'Phone', key: 'phone', type: 'text', value: '+49 (0) 89 25 54 938 - 0' },
    { label: 'Fax', key: 'fax', type: 'text', value: '' }
  ];

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() });
  });

  addPlaceholder();
}

function addPlaceholder() {
  const placeholders = [
    'John Doe',
    'Frontend developer',
    'JohnDoe LLC',
    'Avenue Road 12',
    'mail@jonhdoe.com',
    '+ 1 123 456 7890',
    '+ 1 123 456 7890',
    'META Hotels GmbH',
    'Sitz der Gesellschaft: München • Registergericht: Amtsgericht München',
    'Geschäftsführer: Thomas Ernst, Gerhard Lernberger, Peter Treiber',
    'USt-IdNr.: 203733233'
  ];

  fields.basicPlaceholder = [
    ...fields.basic.map((item, index) => {
      return { ...item, value: placeholders[index] };
    })
  ];
}

seed();

export default fields;
